/**
 * Done Commerce — main entry point.
 */

import { initSearch } from './search.js';
import { initCartDrawer, openCartDrawer } from './cart-drawer.js';
import { initNoticeToasts, showToast } from './toast.js';
import { initFavourites } from './favourites.js';
import { initAuthModal } from './auth-modal.js';
import { initFilters } from './filters.js';
import { initQuantity } from './quantity.js';
import { initPrescriptionUpload } from './prescription-upload.js';
import { initAccount } from './account.js';
import { initProductGallery } from './product-gallery.js';
import { initRecentlyViewed } from './recently-viewed.js';
import { initProductRails } from './product-rails.js';
import { initCheckoutDelivery } from './checkout-delivery.js';
import { initCheckoutFields } from './checkout-fields.js';
import { initCheckoutAddressLookup } from './checkout-address-lookup.js';
import { initStickyCheckout } from './sticky-checkout.js';
import { initProductCardQuickAdd } from './product-card.js';
import { initVariationModal } from './variation-modal.js';
import { initStickyAtc } from './sticky-atc.js';
import { initPdpAddToCart } from './pdp-add-to-cart.js';

function initMobileMenu() {
	const toggle = document.querySelector('[data-mobile-menu-toggle]');
	const nav = document.getElementById('dc-mobile-nav');

	if (!toggle || !nav) {
		return;
	}

	toggle.addEventListener('click', () => {
		const expanded = toggle.getAttribute('aria-expanded') === 'true';
		toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
		nav.hidden = expanded;
	});
}

function initPdpReviewDeepLink() {
	const panel = document.querySelector('#reviews.dc-pdp-accordion');
	if (!panel) {
		return;
	}

	const openReviews = () => {
		if (window.location.hash === '#reviews') {
			panel.open = true;
		}
	};

	openReviews();
	window.addEventListener('hashchange', openReviews);
	document.querySelectorAll('a[href="#reviews"]').forEach((link) => {
		link.addEventListener('click', () => {
			panel.open = true;
		});
	});
}

function initVariablePriceToggle() {
	const form = document.querySelector('.dc-pdp__summary form.variations_form');
	const summaryPrice = document.querySelector('.dc-pdp__summary > .price');
	if (!form || !summaryPrice) {
		return;
	}

	const sync = () => {
		const variationPrice = form.querySelector('.woocommerce-variation-price');
		const hasPrice =
			variationPrice &&
			!variationPrice.hidden &&
			Boolean(variationPrice.textContent && variationPrice.textContent.trim());
		summaryPrice.classList.toggle('is-suppressed', Boolean(hasPrice));
	};

	form.addEventListener('found_variation', sync);
	form.addEventListener('hide_variation', () => {
		summaryPrice.classList.remove('is-suppressed');
	});
	form.addEventListener('reset_data', () => {
		summaryPrice.classList.remove('is-suppressed');
	});
	sync();
}

document.addEventListener('DOMContentLoaded', () => {
	initMobileMenu();
	initSearch();
	initCartDrawer();
	initAuthModal();
	initFavourites();
	initFilters();
	initQuantity();
	initPrescriptionUpload();
	initAccount();
	initProductGallery();
	initRecentlyViewed();
	initProductRails();
	initCheckoutDelivery();
	initCheckoutFields();
	initCheckoutAddressLookup();
	initStickyCheckout();
	initProductCardQuickAdd();
	initVariationModal();
	initStickyAtc();
	initPdpAddToCart();
	initNoticeToasts();
	initPdpReviewDeepLink();
	initVariablePriceToggle();
});

document.body?.addEventListener('added_to_cart', () => {
	const message = window.doneCommerce?.i18n?.addedToCart || 'Added to cart';
	showToast(message);
	openCartDrawer({ announce: message });
});
